import { Channel } from '@/libraries/channel.ts';

const channel = Channel.getInstance('ally');

export default {
	updateOnboardingStep({ commit, state }: any, step: any): void {
		if (!!step) {
			const { allowedOptions } = step;
			commit('SET_OB_ALLOWED_OPTIONS', allowedOptions);
		} else {
			commit('SET_OB_ALLOWED_OPTIONS', null);
		}
		commit('SET_IF_ONBOARDING', true);
	},
	clearOnboardingState({ commit, state}: any): void {
		commit('SET_OB_ALLOWED_OPTIONS', null);
		commit('SET_IF_ONBOARDING', false);
	},
};
